export const WHATSAPP_NUMBER = "5511917761984";
export const WHATSAPP_DISPLAY = "(11) 91776-1984";

const MESSAGES = {
    general:
        "Olá! Vim pelo site da Strondex Tech e gostaria de tirar uma dúvida sobre serviços de TI no Campo Limpo.",
    suporte:
        "Olá! Preciso de suporte técnico de informática (formatação/rede/otimização) no Campo Limpo.",
    sites: "Olá! Gostaria de um orçamento para criação de site / landing page para o meu negócio.",
    cardapio:
        "Olá! Tenho um restaurante/pizzaria/doceria no Campo Limpo e quero conhecer o cardápio digital sem taxas de delivery.",
};

export const waLink = (intent = "general") =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
        MESSAGES[intent] || MESSAGES.general,
    )}`;
